import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  align-items: center;
  padding: 0 ${spacing(4)};
  height: 100%;
  width: 100%;

  overflow: hidden;
  opacity: 1;

  &.disabled {
    opacity: 0.5;
  }

  &.alignRight {
    justify-content: flex-end;
  }
`
